import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Apollo} from "apollo-angular";
import {get_all_company_events, search_company_events} from "../../graphql/getCompanyEvents";
import {debounceTime, distinctUntilChanged} from "rxjs";
import {EnvironmentService} from "../../../environment/environment.service";
import {Router} from "@angular/router";

@Component({
    selector: 'company-events-search',
    templateUrl: './company-events-search.component.html',
    styleUrls: ['./company-events-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsSearchComponent{

  searchText: FormControl = new FormControl("")
  searchEvents:any[] = []
  store:string;
  loading: boolean = false;

  constructor(private apollo: Apollo, private env: EnvironmentService, private router: Router) {
    this.searchText.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((val)=> {
      this.store = val;
      this.searchCompanyEventList(val)
      }
    )
  }

  searchCompanyEventList(value:string){
    if(value && value.trim().length>0){
      this.loading = true;
      let searchQuery = this.apollo.watchQuery({
        query: search_company_events,
        variables: {
          searchLike: '%' + this.store.trim() + '%',
          search: this.store.trim(),
          limit: 50,
        }
      }).valueChanges.subscribe(({data}:any) => {
        this.loading = false;
        let companyEvents = data.search_company_events.data;
        this.searchEvents = companyEvents;
        this.formatResults(this.searchEvents)
        searchQuery.unsubscribe();
      })
    }
  }

  formatResults(results:any){
    let pastEvents: any[] = []
    let futureEvents: any[] = []
    if(results) {

      results.forEach((result:any) => {

        let tempObj = {
          isPast: false,
          data: null,
          activeEventDate: null
        }
        let activeEventDate = result.companyEventDates.length>=2 ? result.companyEventDates.find((date:any) => date.initial_date_time==1) : result.companyEventDates[0]
        tempObj.activeEventDate = activeEventDate
        let today = new Date()
        let date = new Date(activeEventDate.start_date)
        date.setHours(0,0,0,0)
        today.setHours(0,0,0,0)
        tempObj.isPast = date.getTime() <= today.getTime();
        tempObj.data = result
        if(tempObj.isPast && pastEvents.length<10){
          pastEvents.push(tempObj)
        } else if(!tempObj.isPast && futureEvents.length < 10){
          futureEvents.push(tempObj)
        }
      })
      this.searchEvents = [{isPast: false, data: [...futureEvents]}, {isPast: true, data:[...pastEvents]}];
    }
  }

  searchRedirect(value: string){
    this.router.navigate([`/company_events/${value}`])
  }
}
